import { render } from "./QuestionDisplay.vue?vue&type=template&id=74360b2a&scoped=true"
import script from "./QuestionDisplay.vue?vue&type=script&lang=js"
export * from "./QuestionDisplay.vue?vue&type=script&lang=js"

import "./QuestionDisplay.vue?vue&type=style&index=0&id=74360b2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74360b2a"]])

export default __exports__